import type { PlateElementProps } from "platejs/react";
import { PlateElement } from "platejs/react";
import { cn } from "@/lib/utils";

export function BlockquoteElement({ children, className, ...props }: PlateElementProps) {
	return (
		<PlateElement
			{...props}
			as="blockquote"
			className={cn(
				"my-1 border-l-2 border-primary/40 pl-6 italic text-muted-foreground",
				className,
			)}
		>
			{children}
		</PlateElement>
	);
}
